import { type RouteObject } from 'react-router-dom';

import BaseLayout from '../base/BaseLayout';
import { ReactAppWrapperWithoutRouter } from '../common/init/ReactAppWrapper';
import {
    getMicroAppInitialQueryData,
    setMicroAppInitialQueryData,
} from '../common/init/renderMicroApp.utils';
import EpiPageLoader from '../episerver/components/base/EpiPageLoader';

const mainCatchAllRoutes: RouteObject[] = [
    {
        path: '*',
        loader: () => {
            const initialQueryData = getMicroAppInitialQueryData();
            setMicroAppInitialQueryData(initialQueryData);
            return null;
        },
        element: (
            <ReactAppWrapperWithoutRouter>
                <BaseLayout>
                    <EpiPageLoader />
                </BaseLayout>
            </ReactAppWrapperWithoutRouter>
        ),
    },
];

export default mainCatchAllRoutes;
